/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CopyIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          d="M11,7V5l2,2ZM10,3l0,0H6A1,1,0,0,0,5,4v8H3a1,1,0,0,1-1-1V2A1,1,0,0,1,3,1H9a1,1,0,0,1,1,1V3h0ZM7,4h3l0,0V8h4v6.07l-.93.93H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4Z"/>
  ]
  getViewBox = () => '0 0 16 16'
}
